import {
  FETCH_TASKS_SUCCESS,
  ADD_TASK,
  UPDATE_TASK,
  DELETE_TASK,
  SET_SELECTED_TASK,
} from "actions/tasks";
import { produce } from "immer";

const initialState = {
  Tasks: [],
  error: "",
  displayTasks: [],
  selectedTaskId: -1,
  showTaskDate: null,
};

const tasksReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    var key;
    switch (action.type) {
      case FETCH_TASKS_SUCCESS:
        draft.Tasks = action.payload;
        draft.selectedTaskId = -1;
        draft.error = "";
        break;
      case ADD_TASK:
        draft.Tasks = [...draft.Tasks, action.payload];
        draft.selectedTaskId = -1;
        break;
      case UPDATE_TASK:
        key = draft.Tasks.findIndex(
          (T) => parseInt(T.id) === parseInt(action.payload.id)
        );
        draft.Tasks[key] = action.payload;
        draft.selectedTaskId = -1;
        break;
      case DELETE_TASK:
        key = draft.Tasks.findIndex(
          (T) => parseInt(T.id) === parseInt(action.payload.id)
        );
        draft = { Tasks: draft.Tasks.splice(key, 1) };
        draft.selectedTaskId = -1;
        break;
      case SET_SELECTED_TASK:
        draft.selectedTaskId = action.payload;
        break;
      default:
        return state;
    }
  });

export default tasksReducer;
